import { Ban } from "lucide-react";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";

/** The attempt's Cancel control: destructive (red) so it cannot be missed or
 *  confused with the neutral close control, in the top-right of the card and
 *  of the detail drawer. The caller's `onCancel` owns the confirm step
 *  (RegistryPage cancelAttempt) and the request; while it is in flight the
 *  button is disabled and says so. A 44px touch target on phones; the click
 *  never reaches the card, so it cannot also open the details. */
export function CancelAttemptButton({
  onCancel,
  cancelling,
  className,
}: {
  onCancel: () => void;
  cancelling: boolean;
  className?: string;
}) {
  return (
    <Button
      type="button"
      variant="destructive"
      size="sm"
      disabled={cancelling}
      aria-busy={cancelling}
      aria-label="Cancel publish attempt"
      title="Cancel this in-progress attempt: any actively-running compile is stopped immediately (asks to confirm)"
      data-testid="cancel-attempt"
      onClick={(e) => {
        e.stopPropagation();
        onCancel();
      }}
      className={cn(
        "shrink-0 gap-1.5 font-semibold focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-destructive focus-visible:ring-offset-2 focus-visible:ring-offset-background max-[640px]:min-h-11 max-[640px]:min-w-11",
        className,
      )}
    >
      <Ban className="h-4 w-4" aria-hidden />
      {cancelling ? "Cancelling…" : "Cancel"}
    </Button>
  );
}
